import { render, staticRenderFns } from "./index.vue?vue&type=template&id=49b6381b&scoped=true&lang=html"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=49b6381b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b6381b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49b6381b')) {
      api.createRecord('49b6381b', component.options)
    } else {
      api.reload('49b6381b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=49b6381b&scoped=true&lang=html", function () {
      api.rerender('49b6381b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wangEnduit/index.vue"
export default component.exports